'use client';

import { Stack, Typography } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { useMe } from '@prismo-io/feature-auth/providers/me';
import Link from 'next/link';
import type { FC } from 'react';

type Props = {
  title: string;
  url: string;
  buttonName: string;
  userUrl: string;
};

export const SectionHeader: FC<Props> = (props: Props) => {
  const { title, url, buttonName, userUrl } = props;

  const me = useMe();

  const isMe = me && me.url === userUrl;

  return (
    <Stack
      width="100%"
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      component="header"
    >
      <Typography variant="h3">{title}</Typography>

      {isMe && (
        <Button
          LinkComponent={Link}
          href={url}
          variant="text"
          color="inherit"
          sx={{
            p: 0,
            '& .MuiButton-startIcon': {
              display: 'none',
            },
          }}
        >
          {buttonName}
        </Button>
      )}
    </Stack>
  );
};
